// src/pages/salary/components/AllowancesSection.jsx
import { TrendingUp, DollarSign, Activity, Award, FileText } from '.';

const AllowancesSection = ({ payrollData, styles, t, theme, isRTL, onMouseEnter, onMouseLeave }) => {
  const getNumericValue = (value) => {
    const normalizedValue = Number(value ?? 0);
    return Number.isFinite(normalizedValue) ? normalizedValue : 0;
  };

  const transportationAllowances = getNumericValue(
    payrollData.transportationAllowances ?? payrollData.transpotartionAllowances
  );
  const variableSalary = getNumericValue(payrollData.variableSalary);
  const overtimeValue = getNumericValue(payrollData.overtimeValue);
  const bonusValue = getNumericValue(payrollData.bonusValue);
  const expenses = getNumericValue(payrollData.expenses);
  const achievement = getNumericValue(payrollData.achievement);

  const staticAllowances = [
    { show: transportationAllowances > 0, title: t.transportationAllowance, amount: transportationAllowances.toFixed(2), desc: t.transportationAllowanceDesc, icon: TrendingUp },
    { show: variableSalary > 0,           title: t.variableSalaryAllowance,  amount: variableSalary.toFixed(2),           desc: t.variableSalaryDesc,         icon: DollarSign },
    { show: overtimeValue > 0,            title: t.overtimeAllowance,         amount: overtimeValue.toFixed(2),            desc: t.overtimeAllowanceDesc,      icon: Activity,
      rate: `${payrollData.overtimeHours} ${isRTL ? 'ساعة' : 'hrs'}` },
    { show: bonusValue > 0,               title: t.bonusAllowance,            amount: bonusValue.toFixed(2),               desc: t.bonusAllowanceDesc,         icon: Award },
    { show: expenses > 0,                 title: t.expensesAllowance,         amount: expenses.toFixed(2),                 desc: t.expensesAllowanceDesc,      icon: FileText },
    { show: achievement > 0,              title: t.achievementAllowance,      amount: achievement.toFixed(2),              desc: t.achievementAllowanceDesc,   icon: Award },
  ].filter((a) => a.show);

  const dbAllowances = Array.isArray(payrollData.allowances) ? payrollData.allowances : [];

  return (
    <div style={styles.card1}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', direction: isRTL ? 'rtl' : 'ltr', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
          <TrendingUp size={24} color="#2e7cba" />
          <h2 style={{ color: theme === 'dark' ? '#ffffff' : '#0f172a', fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: '700', margin: 0 }}>{t.allowancesBreakdown}</h2>
        </div>
      </div>
      <div style={styles.detailsGrid}>
        {staticAllowances.map((item, i) => (
          <div key={i} style={styles.detailCard} className="hover-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div style={styles.detailHeader}>
              <div style={styles.detailIcon}><item.icon size={24} /></div>
              {item.rate && <span style={styles.detailRate}>{item.rate}</span>}
            </div>
            <h4 style={styles.detailTitle}>{item.title}</h4>
            <p style={styles.detailAmount}>{item.amount} {t.egp}</p>
            <p style={styles.detailDescription}>{item.desc}</p>
          </div>
        ))}

        {dbAllowances.map((allowance, i) => (
          <div key={i} style={styles.detailCard} className="hover-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div style={styles.detailHeader}><div style={styles.detailIcon}><TrendingUp size={24} /></div></div>
            <h4 style={styles.detailTitle}>{allowance.type}</h4>
            <p style={styles.detailAmount}>{getNumericValue(allowance.amount).toFixed(2)} {t.egp}</p>
            {allowance.description && <p style={styles.detailDescription}>{allowance.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllowancesSection;